import React from "react";
import { Paper, Title } from "@mantine/core";
import { HiPlus, HiKey } from "react-icons/hi2";
import CustomSearchBar from "../../../../ui/CustomSearchBar/CustomSearchBar";
import { CustomText } from "../../../../ui/CustomText/CustomText";
import CustomButton from "../../../../ui/CustomButton/CustomButton";

const PermissionFilters = ({
  onSearchChange,
  badgeCount,
  onAddPermission,
  isCreating,
}) => {
  return (
    <div className="flex-shrink-0">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
        <div>
          <Title order={2} size="h3" className="flex items-center gap-2">
            <HiKey size={20} />
            Permissions Management
          </Title>
          <CustomText c="dimmed" size="sm" mt={4}>
            Create and manage system permissions
          </CustomText>
        </div>
        <CustomButton
          onClick={onAddPermission}
          disabled={isCreating}
          loading={isCreating}
          leftSection={<HiPlus size={16} />}
          className="self-start"
        >
          Add Permission
        </CustomButton>
      </div>

      <Paper p="md" withBorder className="mb-6">
        <CustomSearchBar
          placeholder="Search permissions..."
          onSearchChange={onSearchChange}
          badgeCount={badgeCount}
          debounceDelay={500}
        />
      </Paper>
    </div>
  );
};

export default PermissionFilters;
